
export class Foo {
  #prop = [25, 42];

  foo() {
    let [a, b] = this.#prop;
    a++;
    debugger;
    return a + b;
  }
}

export const fooInstance = new Foo();

export function testFunction() {
  fooInstance.foo();
}
